import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { ExternalLink, ChevronRight } from "lucide-react";
import { COLLECTIONS, PRODUCTS_BY_COLLECTION } from "../data";

const Collection = () => {
  const { slug } = useParams();
  const collection = COLLECTIONS.find((c) => c.slug === slug);
  const products = (PRODUCTS_BY_COLLECTION[slug] || []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!collection) {
    return (
      <main className="max-w-[1400px] mx-auto px-6 py-24 text-center">
        <h1 className="heading-font text-3xl mb-4">COLLECTION NOT FOUND</h1>
        <Link to="/" className="text-[#ED1C24] heading-font">Back to Home</Link>
      </main>
    );
  }

  return (
    <main>
      {/* Banner */}
      <section className="relative bg-black h-[220px] md:h-[300px] overflow-hidden">
        <img
          src={collection.image}
          alt={collection.name}
          className="absolute inset-0 w-full h-full object-cover opacity-60"
        />
        <div className="absolute inset-0 bg-black/40" />
        <div className="relative h-full flex flex-col items-center justify-center px-4">
          <h1 className="heading-font text-white text-4xl md:text-6xl tracking-wide text-center">
            {collection.name}
          </h1>
          <div className="flex items-center gap-2 text-white/70 heading-font text-xs mt-3 tracking-wide">
            <Link to="/" className="hover:text-white">HOME</Link>
            <ChevronRight size={14} />
            <span className="text-[#ED1C24]">{collection.name.toUpperCase()}</span>
          </div>
        </div>
      </section>

      {/* Price notice */}
      <div className="bg-gray-50 border-b border-gray-100">
        <p className="max-w-[1400px] mx-auto px-4 md:px-8 py-3 text-center text-sm text-gray-600">
          Visit our store for the latest, up-to-date pricing and availability.
        </p>
      </div>

      {/* Products */}
      <section className="max-w-[1400px] mx-auto px-4 md:px-8 py-12 md:py-16">
        {products.length === 0 ? (
          <div className="text-center py-16">
            <p className="text-gray-600 mb-6">
              Products in this segment are available on our store.
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-8">
            {products.map((p, i) => (
              <a
                key={i}
                href={p.url}
                target="_blank"
                rel="noreferrer"
                className="group block"
              >
                <div className="relative overflow-hidden bg-white border border-gray-100 aspect-square">
                  <img
                    src={p.image}
                    alt={p.name}
                    className="w-full h-full object-contain p-3 transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 flex items-end justify-center pb-4 opacity-0 group-hover:opacity-100 transition-opacity">
                    <span className="inline-flex items-center gap-1 bg-[#ED1C24] text-white heading-font text-xs tracking-wide px-4 py-2">
                      Buy Online <ExternalLink size={13} />
                    </span>
                  </div>
                </div>
                <p className="heading-font text-center mt-3 text-black text-sm md:text-base group-hover:text-[#ED1C24] transition-colors">
                  {p.name}
                </p>
              </a>
            ))}
          </div>
        )}

        <div className="flex justify-center mt-12">
          <a
            href={collection.url}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 bg-black hover:bg-[#ED1C24] text-white heading-font tracking-wide px-8 py-3 transition-colors"
          >
            Buy {collection.name} Online <ExternalLink size={16} />
          </a>
        </div>
      </section>
    </main>
  );
};

export default Collection;
